var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiLabIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3 2.413a.75.75 0 0 1 .75-.75H6a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-.75.75.75.75 0 0 1-.75.75H4.5a.75.75 0 0 1-.75-.75.75.75 0 0 1-.75-.75v-5.25Zm9 6a4.484 4.484 0 0 1-1.146 3h.396a.75.75 0 1 1 0 1.5H.75a.75.75 0 1 1 0-1.5H7.5a3 3 0 1 0 0-6v-1.5c2.484 0 4.5 2.016 4.5 4.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.5.913a.75.75 0 0 0-.75.75H6a.75.75 0 0 0-.75-.75H4.5Zm-1.875 9a.376.376 0 0 0-.375.375c0 .206.169.375.375.375h4.5a.376.376 0 0 0 .375-.375.376.376 0 0 0-.375-.375h-4.5Z"
})));
export default SvgHaidiLabIcon;